var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0403 9.61134C16.4151 9.01742 16.4176 8.24326 16.4176 7.47833C16.4176 3.87782 12.335 4.59885 12.335 4.59885C12.335 4.59885 12.4269 1.62231 9.08677 1.62231C6.00306 1.62231 5.6572 4.55956 5.6572 4.55956C5.6572 4.55956 1.54557 4.19443 1.54557 7.81342C1.54042 8.37714 1.68259 8.93307 1.95915 9.43108L0.662782 9.99958C0.223757 9.27601 -0.00504312 8.45342 8.43221e-05 7.61698C8.43221e-05 5.3892 1.62055 3.06205 4.59543 3.06205C5.22185 1.18784 6.94147 0 9.09887 0C11.6408 0 13.0146 1.50676 13.5104 3.05974C16.1539 3.05974 17.9993 5.18353 17.9993 7.53148C18.0163 8.55383 17.7139 9.55795 17.1311 10.4156L16.0403 9.61134ZM7.28008 13.5007C7.29943 9.29704 9.21496 9.74537 9.45682 6.99071L10.2066 6.88672C11.6336 8.98275 12.0302 10.9817 10.9854 13.6047C12.3785 13.161 12.6421 11.0441 16.2845 11.2937L16.6135 11.4162C16.6135 11.4162 15.6122 15.7354 10.2912 16.5628L9.72287 19.6364L6.77217 19.158L7.66705 16.6159C3.34985 16.0359 1.31339 11.2313 1.31339 11.2313L1.8745 10.6998C3.62799 12.0471 5.46371 11.1042 7.28008 13.5007Z",
    fill: "#12A054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel3);
export default __webpack_public_path__ + "static/media/level-3.1188678146493dd556b76565022230a8.svg";
export { ForwardRef as ReactComponent };